import axiosVApi from '../axiovishwam';

const getFeatureList = async (body) => {
    try {
        if (body?.isActive === undefined) {
            body.isActive = true;
        }
        const response = await axiosVApi.post(`/Feature/getFeatureList`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getFeatureList===>:", error);
    }
};

const GetFeatureDropdown = async (request) => {
    try {
        if (!request) {
            request = {};
        }
        if (request?.isActive === undefined) {
            request.isActive = true;
        }
        const response = await axiosVApi.post(`/Feature/GetFeatureDropdown`, request);
        return response?.data;
    } catch (error) {
        console.log("Error GetFeatureDropdown===>:", error);
        return error?.response?.data;
    }
};

const GetFeatureDropdownForWorkflow = async (request) => {
    try {
        if (!request) {
            request = {};
        }
        if (request?.isActive === undefined) {
            request.isActive = true;
        }
        const response = await axiosVApi.post(`/Feature/GetFeatureDropdownForWorkflow`, request);
        return response?.data;
    } catch (error) {
        console.log("Error GetFeatureDropdownForWorkflow ===>:", error);
        return error?.response?.data;
    }
};

const addFeature = async (body) => {
    try {
        const response = await axiosVApi.post(`Feature/CreateFeature`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addFeature ===>", error);
        return error?.response?.data;
    }
};

const editFeature = async (body) => {
    try {
        const response = await axiosVApi.post(`Feature/UpdateFeature`, body);
        return response?.data;
    } catch (error) {
        console.log("Error editFeature ===>", error);
        return error?.response?.data;
    }
};

const GetFeatureByModule = async (moduleId) => {
    try {
        const response = await axiosVApi.post(`Feature/GetFeatureByModule/` + moduleId);
        return response?.data;
    } catch (error) {
        console.log("Error GetFeatureByModule ===>", error);
        return error?.response?.data;
    }
};

export const FeatureService = {
    getFeatureList,
    addFeature,
    editFeature,
    GetFeatureDropdown,
    GetFeatureDropdownForWorkflow,
    GetFeatureByModule
}